module.exports = __webpack_public_path__ + "img/spawner-idle.8654aee1.png";